import { TransferOrderReceivingUpdatePage } from "@/features/po-receiving/pages/transfer-order/TransferOrderReceivingUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/receiving/transfer-order/$id/update",
)({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["to_receiving.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TransferOrderReceivingUpdatePage,
});
